// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  mutation logout {
    logout
  }
`;
